import axios from 'axios';

export const googleGeocode = axios.create({
    baseURL: 'https://maps.googleapis.com/maps/api/geocode'
})